
import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { AuthDgiFetchAPI } from '../api/PaymentPost/AuthDgi';
import { ClientsFetchAPI } from '../api/Clients';


const getClientType = async (dTipoRec) => {
    let token = undefined;
    try {
        const responseTypeClient = await ClientsFetchAPI.getClientType(token)
        //console.log(responseTypeClient);
        let dataTypes = responseTypeClient.data.data;

        let dataNow = dataTypes.find(type => type.name.toLowerCase() == dTipoRec.toLowerCase())
        if (dataNow != undefined) { return dataNow.id } else { return 2 }
    } catch (err) {
        //console.log(err);
        return 2;
    }
}

export const authenticationDgi = async (Ruc) => {
    if (Ruc == "") {
        return { clientType: 2 };
    } else {
        let token = undefined;
        let data = { ruc: Ruc }
        try {
            const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
            let dataDgi = response.data
            let dTipoRec = dataDgi?.dgi_response?.dTipoRec ? dataDgi.dgi_response.dTipoRec : "Consumidor final"
            let clientType = await getClientType(dTipoRec)


            if (dataDgi.dgi_response.gResProc) {
                if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
                    let dvDgi = dataDgi.dgi_response.dDV
                    if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
                    return { clientType: clientType, billing_name: dataDgi.dgi_response.dNomb, dv: dvDgi };
                } else {
                    return { clientType: 2 }
                }
            }
        } catch (err) {
            //console.log(err);
            return { clientType: 2 }

        }
    }
}


